import useSWR from 'swr';
import type { VendorCompany } from '~/models/VendorCompany';
import type { SwrReturnType } from '~/models/Api';

const paths = {
  index: '/vendors/vendor_partner_candidates'
} as const;

type TIndex = (name: string) => SwrReturnType<VendorCompany[]>;
type ReturnType = {
  index: TIndex;
};

export const useVendorPartnerCandidates = (): ReturnType => {
  const index: TIndex = (name: string) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error, isLoading } = useSWR<VendorCompany[]>({
      url: paths.index,
      params: { name }
    });
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index };
};
